module.exports = __webpack_public_path__ + "img/verification-green.90bc707d.png";